<div class="penalty-container">
    <ng-container *ngIf="showaddPenalty === 'addpenlaty'">
        <div class="addPenalty">
            <form [formGroup]="penaltyForm" class="penaltyForm">
                <div class="penaltySection">
                    <div class="penalty-input">
                        <snl-input class="penalty-input-text" [label]="'Penalty (%)'" [helperText]="searchText" [type]="'text'"
                            [isError]="isPenaltyInputError()"
                            [errorMessage]="getPenaltyInputErrorMessage()"
                            formControlName="penalty" (focusout)="handleFocusOutPenalty($event)">
                        </snl-input>
                    </div>
                    <div class="effectivePoolpoints">
                        <div class="effectivePointstext body-b">Effective pool points</div>
                        <span class="value sub-heading-s1" >{{newEffectivePoolPoints ?( newEffectivePoolPoints | negativeToBracket) : (currentpoolPoint | negativeToBracket)}}</span>
                    </div>
                    <div class="datePickerPenalty input-text">
                        <snl-date-picker-dropdown datePickerType="date-time" 
                            title="Effective date of change" class="date-picker datePickerEnd"
                            [isMilitaryTime]="true" (timeChange)="onTimeChange($event)"
                            (selectedDate)="selectedDate($event)" [min]="minSelectableDate">
                        </snl-date-picker-dropdown>
                        
                    </div>
                    <snl-multi-line-input
                        class="addPanMultiLine"
                        [label]="'Reason for change'"
                        [maxLength]="500"
                        [isError]="isError"
                        (fieldValue)="fieldValue($event)"
                    ></snl-multi-line-input>
                </div> 
            </form>
        </div>
    </ng-container>
    <ng-container *ngIf="showaddPenalty === 'endPenalty'">
        <div class="endPenalty">
            <div class="currentPenalty">
                <div class="currentPenaltytext body-b">Current penalty</div>
                <span class="value sub-heading-s1" >{{endPenlatypercent}} %</span>
            </div>
            <div class="datePickerEndPenalty input-text">          
                <snl-date-picker-dropdown datePickerType="date-time" 
                    title="Effective date of change" class="date-picker datePickerEnd"
                    [isMilitaryTime]="true" (timeChange)="onTimeChange($event)"
                    (selectedDate)="selectedendPenlatyDate($event)" [min]="minSelectableDate">
                </snl-date-picker-dropdown> 
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="showaddPenalty === 'removePenalty'">
        <div class="removePenalty">
            <div class="textWrap">
                <div class="body-b1">You are about to remove the <span class="onGoing sub-heading-s1">ongoing</span> penalty of:</div>
                <ul class="body-b1">
                    <li>Value: {{endPenlatypercent}}%</li>
                    <li>Effective pool points: {{calculatedPoolPoints}}</li>
                    <li>From date: {{removePenaltyDate | date:'d MMM yyyy'}} at {{removePenaltyTime}} UTC</li>
                </ul>
                <br/>
                <div class="body-b1">
                    <ng-container *ngIf="isUsedinCalculation">
                        Removing this penalty <span class="notAffect sub-heading-s1">will not affect distribution</span> calculation for
                        pool {{shipPool}} and ship <span class="shipName sub-heading-s1">{{shipName}}</span>.
                        Are you sure you want to remove it?
                    </ng-container>
                    <ng-container *ngIf="!isUsedinCalculation">
                        This will affect distribution calculation for <span class="poolVal sub-heading-s1">Pool {{shipPool}}</span> and ship <span class="shipName sub-heading-s1">{{shipName}}</span> in the months of 
                        <ng-container *ngIf="dateToDisplayInModal?.length < 2">
                            <span class="date sub-heading-s1">{{dateToDisplayInModal + '-01' | date:'MMM' }} {{currentYear}}</span>. 
                        </ng-container>
                         <ng-container *ngIf="dateToDisplayInModal?.length > 1">
                            <span class="date sub-heading-s1">{{ getMonthShort(dateToDisplayInModal[0]) }} to {{ getMonthShort(dateToDisplayInModal[dateToDisplayInModal.length - 1]) }} {{currentYear}}</span>. 
                        </ng-container>
                        
                        Are you sure you want to remove it?
                    </ng-container>
                </div>       
            </div>
            <snl-multi-line-input class="mt-24"
                    [label]="'Reason for removal'"
                    [maxLength]="250"
                    [isError]="isError"
                    (fieldValue)="removePenaltyFieldVal($event)"
            ></snl-multi-line-input>
            <!-- <div class="btnWrap">
                <snl-button type="secondary" size="large">Cancel</snl-button>
                <snl-button type="primary" size="large">Yes, remove</snl-button>                 
            </div> -->
        </div>
    </ng-container>
   
   
</div>
